export const osName = {
  iOS: 'iOS',
  Android: 'Android',
  Windows: 'Windows',
};
